'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _get = require('./get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'last',
    immutable: 'last',
    object: function object() {
        return function (value) {
            return value[(0, _get2.default)(-1)(Object.keys(value))];
        };
    },
    array: function array() {
        return (0, _get2.default)(-1);
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/last.js
// module id = 156
// module chunks = 35783957827783